import { Directive } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
	selector: '[commonLowerCaseInput]',
})
export class CommonLowerCaseInputDirective {
	private controlSubscription: Subscription;

	constructor (
		private ngModelControl: NgModel,
	) {}

	ngOnInit (): void {
		const { control } = this.ngModelControl;

		this.controlSubscription = control.valueChanges
			.subscribe((value: string) => {
				const newValue = (value || '').toLowerCase();

				if (value && newValue && newValue !== value) {
					control.setValue(newValue, { emitEvent: false });
				}
			});
	}

	ngOnDestroy (): void {
		if (this.controlSubscription) {
			this.controlSubscription.unsubscribe();
		}
	}
}
